export default __webpack_public_path__ + "static/media/triangle.1eec9c09.svg";